import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PrinterReferenceService extends BaseReferenceService {
  constructor() {
    super('PrinterReference');
  }
}
